import React from 'react';
import { motion, useTransform, useSpring } from 'framer-motion';

const VUMeter = ({ level, label = "L" }) => {
    // Map level (0-100) to rotation angle (-45 to 45 degrees)
    const rotation = useTransform(level, [0, 100], [-45, 45]);
    // Slower, heavier needle movement (ballistics)
    const smoothRotation = useSpring(rotation, { stiffness: 120, damping: 20, mass: 1.5 });

    return (
        <div className="relative w-28 h-20 bg-[#fbf9f2] rounded-sm border border-[#bbb] shadow-[inset_0_1px_3px_rgba(0,0,0,0.05)] overflow-hidden flex flex-col items-center justify-end pb-2">

            {/* Warm Backlight / Paper Texture */}
            <div className="absolute inset-0 bg-[#fff] opacity-80 mix-blend-multiply"></div>

            {/* Backlight Glow Overlay */}
            <div className="absolute top-0 left-0 right-0 h-16 bg-gradient-to-b from-[#ffeedd] to-transparent opacity-60 pointer-events-none z-10 mix-blend-multiply"></div>
            <div className="absolute top-0 left-0 right-0 h-2 bg-[#fff5e6] blur-[4px] opacity-80 pointer-events-none z-10"></div>

            {/* Scale Markings */}
            <div className="absolute inset-0 flex justify-center items-end pb-3">
                {/* Arc */}
                <div className="w-24 h-24 border-t-[0.5px] border-l-[0.5px] border-r-[0.5px] border-transparent border-t-[#444] rounded-full absolute top-5 scale-x-125 opacity-50"></div>

                <div className="absolute top-3 w-full flex justify-between px-4 text-[7px] font-sans font-bold text-[#444] opacity-80">
                    <span>-20</span>
                    <span>-10</span>
                    <span>-5</span>
                    <span>0</span>
                    <span className="text-red-600">+3</span>
                </div>
            </div>

            {/* Needle */}
            <motion.div
                className="absolute bottom-[-10%] w-[1.5px] h-[85%] bg-[#333] origin-bottom z-10"
                style={{ rotate: smoothRotation }}
            />

            {/* Needle Cap */}
            <div className="absolute bottom-[-6px] w-4 h-4 bg-[#777] rounded-full z-20 shadow-sm"></div>

            {/* Label */}
            <div className="absolute bottom-1 left-2 text-[8px] font-bold text-[#555] font-sans tracking-wider">{label}</div>

            {/* Glass Reflection / Glare */}
            <div className="absolute inset-0 bg-gradient-to-tr from-white/30 via-transparent to-transparent pointer-events-none z-30"></div>
        </div>
    );
};

export default VUMeter;
